import { createContext } from 'react';

interface FilterContextType {
  isExpanded: boolean,
  setIsExpanded: (isExpanded: boolean) => void,
}

export const FilterContext = createContext<FilterContextType>({
  isExpanded: false,
  setIsExpanded: () => {},
});
